import ToolDashboard from "./ToolDashboard";
import "./index.scss";
const ToolPage = () => {
    return <ToolDashboard />;
};

export default ToolPage;
